import styled from 'styled-components';
import { Layout } from 'antd';

export const UserManagementLayout = styled(Layout)`
    padding: 1.5rem 2.25rem;
    background-color: transparent;
`;